module.exports = require("/opt/build/repo/src/utils/typography")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 515
// module chunks = 231608221292675